// Copyright 2025, University of Maryland, All Rights Reserved



// Create a custom event bus for React components to subscribe to
export type AuthErrorEvent = {
  status: number;
  message: string;
  url?: string;
}

// Simple event emitter for auth errors (used by React components)
export const authEvents = {
  listeners: new Set<(event: AuthErrorEvent) => void>(),

  onAuthError(callback: (event: AuthErrorEvent) => void) {
    this.listeners.add(callback);
    return () => {
      this.listeners.delete(callback);
    };
  },

  emitAuthError(event: AuthErrorEvent) {
    this.listeners.forEach(listener => {
      try {
        listener(event);
      } catch (error) {
        console.error('Error in auth error listener:', error);
      }
    });
  }
};